/**
 * @author jakubmaslon
 * @since 2019-08-13
 */

import * as React from "react";
import styled from "styled-components";

import theme from "@ui/themes/default";
import { rem } from "@ui/helpers";
import { Paragraph } from "@ui/Atoms";

interface Props {
  stepNumber?: number;
  icon: React.ReactNode;
  description: string;
}

const OnboardingStep = (props: Props): React.ReactElement => (
  <Wrapper>
    {props.stepNumber && <StepNumber>{props.stepNumber}</StepNumber>}
    <IconWrapper>{props.icon}</IconWrapper>
    <OnboardingParagraph type="body">{props.description}</OnboardingParagraph>
  </Wrapper>
);

export { OnboardingStep };

const IconWrapper = styled.div`
  position: relative;
  margin-bottom: ${theme.margins.base_x4};
  max-height: ${rem(104)};

  svg {
    max-height: ${rem(104)};
  }
`;

const StepNumber = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${rem(26)};
  height: ${rem(26)};
  margin-bottom: ${theme.margins.base_x4};
  border-radius: 50%;
  color: ${theme.palette.blue500};
  background: ${theme.palette.white};
  font-weight: ${theme.fonts.weights.semibold};
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${theme.margins.base_x4} ${theme.margins.base_x2};
  border-radius: ${theme.margins.base};
  text-align: center;
  background: ${theme.palette.grey50};
  overflow: hidden;
`;

const OnboardingParagraph = styled(Paragraph)`
  overflow: scroll;
`;
